(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[607],{

/***/ 10110:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contactwithus",
      function () {
        return __webpack_require__(80679);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CustomTextArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67191);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var CustomTextArea = function(_param) {
    var inpValue = _param.inpValue, label = _param.label, value = _param.value, className = _param.className, handleChange = _param.handleChange, _withStar = _param.withStar, withStar = _withStar === void 0 ? false : _withStar, _custom = _param.custom, custom = _custom === void 0 ? false : _custom, required = _param.required, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "inpValue",
        "label",
        "value",
        "className",
        "handleChange",
        "withStar",
        "custom",
        "required"
    ]);
    var LabelName = custom ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: value
    }) : value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().custom_textArea_checkout),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().custom_textarea),
                id: props.name,
                placeholder: " ",
                required: !!required,
                autoComplete: "off",
                value: inpValue,
                onChange: handleChange
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().custom_input_label),
                htmlFor: props.name,
                children: [
                    LabelName,
                    withStar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["red-fms"]),
                        children: " *"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 78624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CustomTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75681);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67191);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var CustomTextField = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "" : _type, _inpValue = _param.inpValue, inpValue = _inpValue === void 0 ? "" : _inpValue, _label = _param.label, label = _label === void 0 ? "" : _label, _value = _param.value, value = _value === void 0 ? "" : _value, _className = _param.className, className = _className === void 0 ? "" : _className, handleChange = _param.handleChange, _withStar = _param.withStar, withStar = _withStar === void 0 ? false : _withStar, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, _isUsed = _param.isUsed, isUsed = _isUsed === void 0 ? "" : _isUsed, code = _param.code, required = _param.required, _pattern = _param.pattern, pattern = _pattern === void 0 ? "" : _pattern, _err = _param.err, err = _err === void 0 ? false : _err, _custom = _param.custom, custom = _custom === void 0 ? false : _custom, _id = _param.id, id = _id === void 0 ? "" : _id, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "type",
        "inpValue",
        "label",
        "value",
        "className",
        "handleChange",
        "withStar",
        "defaultValue",
        "isUsed",
        "code",
        "required",
        "pattern",
        "err",
        "custom",
        "id"
    ]);
    var newType = type ? type : "text";
    var customClassName = className ? className : "";
    var generatedId = id ? id : props.name + (0,_services_utils__WEBPACK_IMPORTED_MODULE_2__/* .idGen */ ["do"])();
    var newPattern = pattern ? pattern : "";
    var LabelName = custom ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: value
    }) : value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().custom_input_checkout), " ").concat(customClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: "".concat((_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().custom_input_field), " ").concat(err && (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().err_field)),
                id: generatedId,
                type: newType,
                placeholder: " ",
                autoComplete: "off",
                value: isUsed ? code : inpValue,
                onChange: handleChange,
                disabled: !!isUsed
            }, props), {
                required: !!required
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().custom_input_label),
                htmlFor: generatedId,
                children: [
                    LabelName,
                    withStar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["red-fms"]),
                        children: " *"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 69607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AP": function() { return /* reexport */ CustomSelect; },
  "Ks": function() { return /* reexport */ CustomTextArea/* CustomTextArea */.K; },
  "yM": function() { return /* reexport */ CustomTextField/* CustomTextField */.y; }
});

// EXTERNAL MODULE: ./atoms/CustomTextField.tsx
var CustomTextField = __webpack_require__(78624);
// EXTERNAL MODULE: ./atoms/CustomTextArea.tsx
var CustomTextArea = __webpack_require__(77280);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./atoms/atoms.module.scss
var atoms_module = __webpack_require__(67191);
var atoms_module_default = /*#__PURE__*/__webpack_require__.n(atoms_module);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./atoms/CustomSelect.tsx
/**
 *   was created by tigran at 05.10.23
 **/ 





var CustomSelect = function(param) {
    var onChange = param.onChange, defaultSelected = param.defaultSelected, selectList = param.selectList, _asterisk = param.asterisk, asterisk = _asterisk === void 0 ? false : _asterisk, messageId = param.messageId, name = param.name, printedFieldName = param.printedFieldName, translationsData = param.translationsData, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, fullHeight = param.fullHeight, containerHeight = param.containerHeight;
    var defSelectedAttribute = defaultSelected ? {
        defaultValue: defaultSelected
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (atoms_module_default()).select_wrapper,
        children: selectList && selectList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (atoms_module_default()).select_label_title,
                    children: [
                        translationsData[messageId],
                        asterisk && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (atoms_module_default()).select_asterisk,
                            children: " *"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (atoms_module_default()).select_container,
                    style: containerHeight ? {
                        height: "".concat(containerHeight, "px")
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: (atoms_module_default()).select_width,
                            name: name,
                            onChange: onChange,
                            style: fullHeight ? {
                                height: "100%"
                            } : {}
                        }, defSelectedAttribute), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    disabled: disabled,
                                    children: translationsData[messageId]
                                }),
                                selectList.map(function(option, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: option[printedFieldName],
                                        children: option[printedFieldName]
                                    }, index);
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (atoms_module_default()).caret_wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {})
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./atoms/index.ts





/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 80679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contactwithus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./atoms/index.ts + 1 modules
var atoms = __webpack_require__(69607);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(54213);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
// EXTERNAL MODULE: ./node_modules/next-recaptcha-v3/lib/index.js + 5 modules
var lib = __webpack_require__(69498);
;// CONCATENATED MODULE: ./components/footer/ContactWithUs.tsx














var ContactWithUs = function(param) {
    var translationsData = param.translationsData, breadcrumb = param.breadcrumb, recaptchaActive = param.recaptchaActive, dbName = param.dbName;
    var toast = (0,useToast/* useToast */.p)();
    var initialValues = {
        email: "",
        full_name: "",
        phone: "",
        message: ""
    };
    var ref = (0,react.useState)(initialValues), formValues = ref[0], setFormValues = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], _ = ref1[1];
    var ref2 = (0,react.useState)({}), formErrors = ref2[0], setFormErrors = ref2[1];
    var executeRecaptcha = (0,lib/* useReCaptcha */.CL)().executeRecaptcha;
    var history = (0,next_router.useRouter)();
    var submitForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var body, token, options;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFormErrors(validate(formValues));
                        body = formValues;
                        if (!(String(recaptchaActive) === "1")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeRecaptcha("form_submit")
                        ];
                    case 1:
                        token = _state.sent();
                        body = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), {
                            re_token: token
                        });
                        _state.label = 2;
                    case 2:
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        };
                        fetch((0,helper/* apiUrlWithStore */.St)("/api/contact-us-send"), options).then(function(response) {
                            return response.json();
                        }).then(function(res) {
                            if (res.success === true) {
                                // FIXME warning
                                history.push("/");
                                //@ts-ignore
                                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "d-flex chek-fms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                                        translationsData.MessageSentSuccessfully
                                    ]
                                }));
                            }
                        }).catch(function(err) {
                            return console.error(err);
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function submitForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChange = function(e) {
        setFormValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    // const handleSubmit = (e: { preventDefault: () => void; }) => {
    //     e.preventDefault();
    //     setFormErrors(validate(formValues));
    //     setIsSubmitting(true);
    // };
    var validate = function(values) {
        var errors = {
            name: "",
            email: "",
            message: ""
        };
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        // const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (!values.full_name) {
            errors.name = "the_first_name_field_is_required";
        }
        if (!values.email) {
            errors.email = "the_email_field_is_required";
        }
        if (values.email && !regex.test(values.email)) {
            errors.invalidEmail = "invalid_email_format";
        }
        if (!values.message) {
            errors.message = "this_field_is_required";
        }
        if (!values.phone) {
            errors.phone = "the_phone_field_is_required.";
        }
        return errors;
    };
    (0,react.useEffect)(function() {
        if (Object.keys(formErrors).length === 0 && isSubmitting) {
            (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                submitForm()
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })();
        }
    }, [
        formErrors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                header: "",
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container contact-with-us",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "contact-customhtml-fms",
                        children: translationsData.ContactWithUs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "fieldset-params-fms",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "contact_field",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                        withStar: true,
                                        type: "email",
                                        value: translationsData.Email,
                                        className: "contact-with-input",
                                        handleChange: handleChange,
                                        name: "email",
                                        inpValue: formValues.email
                                    }),
                                    (formErrors === null || formErrors === void 0 ? void 0 : formErrors.email) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "alert-danger",
                                        children: translationsData.TheEmailFieldIsRequired
                                    }) : (formErrors === null || formErrors === void 0 ? void 0 : formErrors.invalidEmail) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "alert-danger",
                                        children: translationsData.InvalidEmailFormat
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "contact_field",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                        className: "contact-with-input",
                                        value: translationsData.FirstName,
                                        withStar: true,
                                        handleChange: handleChange,
                                        name: "full_name",
                                        inpValue: formValues.full_name
                                    }),
                                    (formErrors === null || formErrors === void 0 ? void 0 : formErrors.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "alert-danger",
                                        children: translationsData.ThisFieldIsRequired
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "contact_field",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                        type: "number",
                                        value: translationsData.Phone,
                                        className: "contact-with-input",
                                        withStar: true,
                                        handleChange: handleChange,
                                        name: "phone",
                                        inpValue: formValues.phone
                                    }),
                                    (formErrors === null || formErrors === void 0 ? void 0 : formErrors.phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "alert-danger",
                                        children: translationsData.ThePhoneFieldIsRequired
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "comment required",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextArea */.Ks, {
                                    id: "outlined-message-input_5",
                                    className: "comment-field",
                                    label: "Comment message",
                                    inpValue: formValues.message,
                                    value: translationsData.Comment,
                                    withStar: true,
                                    type: "text",
                                    handleChange: handleChange,
                                    name: "message"
                                }),
                                (formErrors === null || formErrors === void 0 ? void 0 : formErrors.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "alert-danger",
                                    children: translationsData.ThisFieldIsRequired
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "action-fms",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: submitForm,
                            className: "btn btn-orange inner-addToCart rounde-pills btn-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: translationsData.Send
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer_ContactWithUs = (ContactWithUs);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 31 modules
var MainLayout = __webpack_require__(76529);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/shared/ReCaptchaWrapper.tsx
var ReCaptchaWrapper = __webpack_require__(2598);
;// CONCATENATED MODULE: ./pages/contactwithus.tsx










var Contactwithus = function(pageProps) {
    var dbName = pageProps.dbName, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, recaptchaActive = pageProps.recaptchaActive, recaptchaKey = pageProps.recaptchaKey, domain = pageProps.domain, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var router = (0,next_router.useRouter)();
    var meta_title = translationsData.ContactWithUs;
    var meta_description = "contact with us page";
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    var companyNameConverter = " | " + domain.charAt(0).toUpperCase() + domain.slice(1).replace(/[-_]/g, " ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptchaWrapper/* default */.Z, {
        recaptchaActive: recaptchaActive,
        recaptchaKey: recaptchaKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "title",
                                content: meta_title + companyNameConverter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "generator",
                                content: "Zegashop.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: meta_url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:locale",
                                content: selectedLocale
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: meta_url
                            }),
                            (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                        hrefLang: "x-default"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                        hrefLang: defaultLangCode
                                    }),
                                    locales.map(function(intl) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            rel: "alternate",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                            hrefLang: intl.code
                                        });
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_ContactWithUs, {
                        dbName: dbName,
                        breadcrumb: breadcrumb,
                        translationsData: translationsData,
                        recaptchaActive: recaptchaActive
                    })
                ]
            })
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var contactwithus = (Contactwithus);


/***/ }),

/***/ 67191:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select_global":"atoms_select_global__9eedR","toasts-wrapper":"atoms_toasts-wrapper__f9E7x","toast":"atoms_toast__c1BL3","toast-in-right":"atoms_toast-in-right__oeYsw","toast__text":"atoms_toast__text__EPBnn","toast__close-btn":"atoms_toast__close-btn__dMM0t","custom_textArea_checkout":"atoms_custom_textArea_checkout__07AIE","custom_textarea":"atoms_custom_textarea__bxfYq","custom_input_label":"atoms_custom_input_label__dMW0i","custom_input_field":"atoms_custom_input_field__8JhNw","red-fms":"atoms_red-fms__gy8KO","custom_input_checkout":"atoms_custom_input_checkout__QDlqs","err_field":"atoms_err_field__aGr7k","signUp-position-relative":"atoms_signUp-position-relative__Q1wgP","form-group":"atoms_form-group__lbJzQ","input-paddings":"atoms_input-paddings__WnO_x","signUp-position-radio-flex":"atoms_signUp-position-radio-flex___S_MV","signUp-position-no-input":"atoms_signUp-position-no-input__7Zhfu","custom_multiselect":"atoms_custom_multiselect__xCPeT","open":"atoms_open__499_m","custom_select-button":"atoms_custom_select-button__R9Agp","custom_multiselect-arrow":"atoms_custom_multiselect-arrow__e_Dc6","custom_multiselect-drop_down":"atoms_custom_multiselect-drop_down__yTDyD","custom_multiselect-button":"atoms_custom_multiselect-button__xacoC","custom_multiselect-button_selected":"atoms_custom_multiselect-button_selected__lOZW7","selected_del_btn":"atoms_selected_del_btn__kgNNw","custom_multiselect-option":"atoms_custom_multiselect-option__TbKPh","selected_option":"atoms_selected_option__C10_7","signUp-position-yes-no":"atoms_signUp-position-yes-no__kakyJ","signUp-position-yes-input":"atoms_signUp-position-yes-input__wAo2f","drop_down":"atoms_drop_down__oFda3","drop_down_btn":"atoms_drop_down_btn__ZShbQ","drop_down_arrow":"atoms_drop_down_arrow__CX3gx","drop_down_opened":"atoms_drop_down_opened___THG_","drop_down_block":"atoms_drop_down_block__ZrZ9T","drop_down_option":"atoms_drop_down_option__KFMWc","select_wrapper":"atoms_select_wrapper__pzpP1","select_label_title":"atoms_select_label_title__FkHzd","select_asterisk":"atoms_select_asterisk__ycLWy","select_container":"atoms_select_container__xwpkP","select_width":"atoms_select_width__GyLl1","caret_wrapper":"atoms_caret_wrapper__GSM1Z"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,3997,5224,9774,2888,179], function() { return __webpack_exec__(10110); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);